import { Text } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { Image } from 'react-native';

import { LoyaltyPartnerTile } from '../loyalty-partner-tile';

const MASTERCARD_URL = '/mastercard';

const MASTERCARD_IMAGE_WIDTH = 96;
const MASTERCARD_IMAGE_HEIGHT = 96;
const MASTERCARD_IMAGE_URI =
  'https://cdn.sanity.io/images/kjfd81ul/prod_bk_us/fa32d487a257d85d5ae000ba77bfef96f89cbec3-192x192.png';

export const MastercardTile = () => {
  const router = useRouter();
  const handlePress = () => {
    router.navigate(MASTERCARD_URL);
  };

  return (
    <LoyaltyPartnerTile
      onPress={handlePress}
      image={
        <Image
          style={{ width: MASTERCARD_IMAGE_WIDTH, height: MASTERCARD_IMAGE_HEIGHT }}
          source={{
            uri: MASTERCARD_IMAGE_URI,
          }}
        />
      }
      title="BK & Mastercard"
      description={[
        <>
          Use your <Text fontWeight="bold">Mastercard®</Text> and unlock an{' '}
          <Text fontWeight="bold">exclusive BK Reward</Text> — only at Burger King®. Grab your
          favorites, tap to pay, and get rewarded for every flame-grilled bite.
        </>,
      ]}
      ctaLabel="Learn More"
      onCTAPress={handlePress}
    />
  );
};
